import login from './login.service'
import users from './users.service'
import category from './category.service'
import product from './product.service'
import proposal from './proposal.service'
import address from './address.service'
import order from './order.service'
import NotificationMSG from './notification.service'



const services = {
    loginService: login,
    usersService: users,
    productService: product,
    categoryService: category,
    proposalService: proposal,
    addressService: address,
    orderService: order,
    notificationService: NotificationMSG,

}

export default services